import CommonEnUS from '@/locales/en-US/common';
import ComponentEnUS from '@/locales/en-US/component';
import GlobalHeaderEnUS from '@/locales/en-US/globalHeader';
import MenuEnUS from '@/locales/en-US/menu';
import PagesEnUS from '@/locales/en-US/pages';
import PwaEnUS from '@/locales/en-US/pwa';
import SettingDrawerEnUS from '@/locales/en-US/settingDrawer';
import SettingsEnUS from '@/locales/en-US/settings';
import PagesSpaceBandLocalesEnUS from '@/pages-pool-member/space/band/locales/en-US';

export default {
  ...PagesSpaceBandLocalesEnUS,
  ...CommonEnUS,
  ...ComponentEnUS,
  ...GlobalHeaderEnUS,
  ...MenuEnUS,
  ...PagesEnUS,
  ...PwaEnUS,
  ...SettingDrawerEnUS,
  ...SettingsEnUS,
};
